import { EventrDate } from "@eventr/common";
import { ColoursObj, TEventrIcons } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import { useMemo } from "react";
import { getMinutesFromUnixTimestamp } from "utils";
import { useFormatValue } from "../../hooks/useFormatValue";
import { CardText } from "../subComponents/cardText";
import { ColouredIcon } from "../subComponents/colouredIcon";
import { DisplayLabel } from "../subComponents/displayLabel";
import i18n from "i18n/i18next";
import { isSameDay } from "../card-utils";

interface IActivityHeaderProps {
  activityName?: string;
  visibility?: string;
  label?: string;
  labelTime?: string;
  start?: string;
  end?: string;
  icon?: { image: string; colour: string };
  date?: string;
}

export const ActivityHeader = ({
  activityName,
  visibility,
  label,
  labelTime,
  start,
  end,
  icon,
  date,
}: IActivityHeaderProps) => {
  const { formatValue } = useFormatValue();
  const labelOverride = useMemo(() => {
    if (date) {
      if (start && isSameDay(date, start)) {
        return `${i18n.t("cards.starts")} ${formatValue(start, "time")}`;
      }
      if (end && isSameDay(date, end)) {
        return `${i18n.t("cards.ends")} ${formatValue(end, "time")}`;
      }
      return undefined;
    }
    if (!start || !end) return null;
    if (
      getMinutesFromUnixTimestamp(new EventrDate(start).getUnixMs) ===
      getMinutesFromUnixTimestamp(new EventrDate(end).getUnixMs)
    )
      return formatValue(start, "time");
    return null;
  }, [date, start, end, formatValue]);

  return (
    <Stack direction="row" sx={{
      justifyContent: "space-between"
    }}>
      <Stack direction="row" sx={{
        gap: "8px"
      }}>
        <ColouredIcon
          name={(icon?.image ?? "Activity") as TEventrIcons}
          iconColour={icon?.colour ?? ColoursObj.core.secondary}
        />
        <CardText variant="bodyBold">{activityName}</CardText>
      </Stack>
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "8px"
        }}>
        {visibility?.toLowerCase() === "private" ? (
          <ColouredIcon height="16px" name="Private" />
        ) : (
          visibility?.toLowerCase() === "public" && <ColouredIcon height="16px" name="Public" />
        )}

        <DisplayLabel label={label} overrideLabel={labelOverride} labelTime={labelTime} />
      </Stack>
    </Stack>
  );
};
